// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOcrEligibleExpenseDto } from './IOcrEligibleExpenseDto';
import {
    IOcrEligibleExpenseDtoFromJSON,
    IOcrEligibleExpenseDtoFromJSONTyped,
    IOcrEligibleExpenseDtoToJSON,
    IOcrEligibleExpenseDtoToJSONTyped,
} from './IOcrEligibleExpenseDto';
import type { IOcrClaimDtoWarningsInner } from './IOcrClaimDtoWarningsInner';
import {
    IOcrClaimDtoWarningsInnerFromJSON,
    IOcrClaimDtoWarningsInnerFromJSONTyped,
    IOcrClaimDtoWarningsInnerToJSON,
    IOcrClaimDtoWarningsInnerToJSONTyped,
} from './IOcrClaimDtoWarningsInner';
import type { IOcrExpenseFieldDto } from './IOcrExpenseFieldDto';
import {
    IOcrExpenseFieldDtoFromJSON,
    IOcrExpenseFieldDtoFromJSONTyped,
    IOcrExpenseFieldDtoToJSON,
    IOcrExpenseFieldDtoToJSONTyped,
} from './IOcrExpenseFieldDto';
import type { IOcrProviderDto } from './IOcrProviderDto';
import {
    IOcrProviderDtoFromJSON,
    IOcrProviderDtoFromJSONTyped,
    IOcrProviderDtoToJSON,
    IOcrProviderDtoToJSONTyped,
} from './IOcrProviderDto';
import type { IAddress } from './IAddress';
import {
    IAddressFromJSON,
    IAddressFromJSONTyped,
    IAddressToJSON,
    IAddressToJSONTyped,
} from './IAddress';
import type { IOcrFieldDto } from './IOcrFieldDto';
import {
    IOcrFieldDtoFromJSON,
    IOcrFieldDtoFromJSONTyped,
    IOcrFieldDtoToJSON,
    IOcrFieldDtoToJSONTyped,
} from './IOcrFieldDto';

/**
 * 
 * @export
 * @interface IOcrReceiptResponseDto
 */
export interface IOcrReceiptResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IOcrReceiptResponseDto
     */
    ocr_receipt_id?: number;
    /**
     * 
     * @type {IAddress}
     * @memberof IOcrReceiptResponseDto
     */
    address?: IAddress;
    /**
     * 
     * @type {IOcrProviderDto}
     * @memberof IOcrReceiptResponseDto
     */
    provider_dto?: IOcrProviderDto;
    /**
     * 
     * @type {number}
     * @memberof IOcrReceiptResponseDto
     */
    duplicate_document_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IOcrReceiptResponseDto
     */
    duplicate_receipt_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IOcrReceiptResponseDto
     */
    is_handwritten?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IOcrReceiptResponseDto
     */
    is_sigis_list_used?: boolean;
    /**
     * 
     * @type {Array<IOcrFieldDto>}
     * @memberof IOcrReceiptResponseDto
     */
    facility_names?: Array<IOcrFieldDto>;
    /**
     * 
     * @type {Array<IOcrFieldDto>}
     * @memberof IOcrReceiptResponseDto
     */
    patients?: Array<IOcrFieldDto>;
    /**
     * 
     * @type {Array<IOcrFieldDto>}
     * @memberof IOcrReceiptResponseDto
     */
    service_dates?: Array<IOcrFieldDto>;
    /**
     * 
     * @type {Array<IOcrFieldDto>}
     * @memberof IOcrReceiptResponseDto
     */
    amounts?: Array<IOcrFieldDto>;
    /**
     * 
     * @type {Array<IOcrFieldDto>}
     * @memberof IOcrReceiptResponseDto
     */
    services?: Array<IOcrFieldDto>;
    /**
     * 
     * @type {Array<IOcrFieldDto>}
     * @memberof IOcrReceiptResponseDto
     */
    accounts?: Array<IOcrFieldDto>;
    /**
     * 
     * @type {Array<IOcrFieldDto>}
     * @memberof IOcrReceiptResponseDto
     */
    invoices?: Array<IOcrFieldDto>;
    /**
     * 
     * @type {Array<IOcrClaimDtoWarningsInner>}
     * @memberof IOcrReceiptResponseDto
     */
    warnings?: Array<IOcrClaimDtoWarningsInner>;
    /**
     * 
     * @type {Array<IOcrExpenseFieldDto>}
     * @memberof IOcrReceiptResponseDto
     */
    expenses?: Array<IOcrExpenseFieldDto>;
    /**
     * 
     * @type {Array<IOcrEligibleExpenseDto>}
     * @memberof IOcrReceiptResponseDto
     */
    eligible_expenses?: Array<IOcrEligibleExpenseDto>;
}

/**
 * Check if a given object implements the IOcrReceiptResponseDto interface.
 */
export function instanceOfIOcrReceiptResponseDto(value: object): value is IOcrReceiptResponseDto {
    return true;
}

export function IOcrReceiptResponseDtoFromJSON(json: any): IOcrReceiptResponseDto {
    return IOcrReceiptResponseDtoFromJSONTyped(json, false);
}

export function IOcrReceiptResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrReceiptResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ocr_receipt_id': json['ocr_receipt_id'] == null ? undefined : json['ocr_receipt_id'],
        'address': json['address'] == null ? undefined : IAddressFromJSON(json['address']),
        'provider_dto': json['provider_dto'] == null ? undefined : IOcrProviderDtoFromJSON(json['provider_dto']),
        'duplicate_document_id': json['duplicate_document_id'] == null ? undefined : json['duplicate_document_id'],
        'duplicate_receipt_id': json['duplicate_receipt_id'] == null ? undefined : json['duplicate_receipt_id'],
        'is_handwritten': json['is_handwritten'] == null ? undefined : json['is_handwritten'],
        'is_sigis_list_used': json['is_sigis_list_used'] == null ? undefined : json['is_sigis_list_used'],
        'facility_names': json['facility_names'] == null ? undefined : ((json['facility_names'] as Array<any>).map(IOcrFieldDtoFromJSON)),
        'patients': json['patients'] == null ? undefined : ((json['patients'] as Array<any>).map(IOcrFieldDtoFromJSON)),
        'service_dates': json['service_dates'] == null ? undefined : ((json['service_dates'] as Array<any>).map(IOcrFieldDtoFromJSON)),
        'amounts': json['amounts'] == null ? undefined : ((json['amounts'] as Array<any>).map(IOcrFieldDtoFromJSON)),
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(IOcrFieldDtoFromJSON)),
        'accounts': json['accounts'] == null ? undefined : ((json['accounts'] as Array<any>).map(IOcrFieldDtoFromJSON)),
        'invoices': json['invoices'] == null ? undefined : ((json['invoices'] as Array<any>).map(IOcrFieldDtoFromJSON)),
        'warnings': json['warnings'] == null ? undefined : ((json['warnings'] as Array<any>).map(IOcrClaimDtoWarningsInnerFromJSON)),
        'expenses': json['expenses'] == null ? undefined : ((json['expenses'] as Array<any>).map(IOcrExpenseFieldDtoFromJSON)),
        'eligible_expenses': json['eligible_expenses'] == null ? undefined : ((json['eligible_expenses'] as Array<any>).map(IOcrEligibleExpenseDtoFromJSON)),
    };
}

export function IOcrReceiptResponseDtoToJSON(json: any): IOcrReceiptResponseDto {
    return IOcrReceiptResponseDtoToJSONTyped(json, false);
}

export function IOcrReceiptResponseDtoToJSONTyped(value?: IOcrReceiptResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ocr_receipt_id': value['ocr_receipt_id'],
        'address': IAddressToJSON(value['address']),
        'provider_dto': IOcrProviderDtoToJSON(value['provider_dto']),
        'duplicate_document_id': value['duplicate_document_id'],
        'duplicate_receipt_id': value['duplicate_receipt_id'],
        'is_handwritten': value['is_handwritten'],
        'is_sigis_list_used': value['is_sigis_list_used'],
        'facility_names': value['facility_names'] == null ? undefined : ((value['facility_names'] as Array<any>).map(IOcrFieldDtoToJSON)),
        'patients': value['patients'] == null ? undefined : ((value['patients'] as Array<any>).map(IOcrFieldDtoToJSON)),
        'service_dates': value['service_dates'] == null ? undefined : ((value['service_dates'] as Array<any>).map(IOcrFieldDtoToJSON)),
        'amounts': value['amounts'] == null ? undefined : ((value['amounts'] as Array<any>).map(IOcrFieldDtoToJSON)),
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(IOcrFieldDtoToJSON)),
        'accounts': value['accounts'] == null ? undefined : ((value['accounts'] as Array<any>).map(IOcrFieldDtoToJSON)),
        'invoices': value['invoices'] == null ? undefined : ((value['invoices'] as Array<any>).map(IOcrFieldDtoToJSON)),
        'warnings': value['warnings'] == null ? undefined : ((value['warnings'] as Array<any>).map(IOcrClaimDtoWarningsInnerToJSON)),
        'expenses': value['expenses'] == null ? undefined : ((value['expenses'] as Array<any>).map(IOcrExpenseFieldDtoToJSON)),
        'eligible_expenses': value['eligible_expenses'] == null ? undefined : ((value['eligible_expenses'] as Array<any>).map(IOcrEligibleExpenseDtoToJSON)),
    };
}

